import axios from 'axios';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { IoPlayBackCircleOutline } from 'react-icons/io5';
import {workerRegister} from '../../Services.js/WorkerApi'
import { FaArrowLeft } from 'react-icons/fa';

const Workprovideregister = () => {
  const navigate = useNavigate();
  const [whatsapp, setwhatsapp] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();
  console.log("Form submission started");
  setIsLoading(true);

  try {

  let phone = whatsapp.toString().trim();
      
      if (phone.startsWith("+")) {
        phone = phone.slice(1);
      }
      
      if (!phone.startsWith("91")) {
        phone = "91" + phone;
      }
      
      if (!/^\d{12}$/.test(phone)) {
        toast.error("watsapp Number Should Be 10 Digit")
        return 
      }

    const formData = { contactNo:phone, password, name,role:"provider" };
    console.log("Form Data:", formData);

    // If your backend expects just formData directly:
    const response = await axios.post(workerRegister, {formdata:formData});

    console.log("Server Response:", response);

     
      if (response?.data?.data?.data?.response === false) {
        toast.error(response.data.message);
      } else {
        toast.success('Registration successful!');
        localStorage.setItem('todaywhatsapp', phone);
        navigate('/otp',{ state: {type:"provider"} });
      }
  } catch (error) {
    console.error('Registration error:', error);
    toast.error(error.response?.data?.message || 'An error occurred. Please try again.');
  } finally {
    setIsLoading(false);
  }
};


  return (
    <div className="min-h-screen bg-provider w-full flex items-center justify-end bg-red-50 p-4">
      <div className="bg-white w-full max-w-md shadow-xl rounded-xl overflow-hidden">
        {/* Header with red accent */}
        <div className="bg-black py-4 px-6">
                      <FaArrowLeft onClick={()=>navigate('/')} style={{cursor:"pointer"}} color='white' size={24} />
          
\          
          <div className='w-full flex items-center justify-center'>
            <img style={{height:"70px",width:"70px"}} src='/kooliapplogo.png' alt='Logo' />
          </div>
          <h2 className="text-2xl font-bold text-white text-center">Create Your Account</h2>
        </div>

        <div className="p-8">
          <form className="space-y-5" onSubmit={handleSubmit}>
            {/* Name Input */}
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                {/* Full Name */}
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                  </svg>
                </div>
                <input
                  type="text"
                  id="name"
                  className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition-all"
                  placeholder="Name"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
            </div>

            {/* whatsapp Input */}
            <div>
              <label htmlFor="whatsapp" className="block text-sm font-medium text-gray-700 mb-1">
                {/* whatsapp Address */}
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <input
                  type="whatsapp"
                  id="whatsapp"
                  className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition-all"
                  placeholder="whatsapp"
                  required
                  value={whatsapp}
                  onChange={(e) => setwhatsapp(e.target.value)}
                />
              </div>
            </div>

            {/* Password Input */}
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                {/* Password */}
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                  </svg>
                </div>
                <input
                  type="password"
                  id="password"
                  className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition-all"
                  placeholder="Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            {/* Register Button */}
            <button
              type="submit"
              disabled={isLoading}
              className={`w-full py-3 px-4 rounded-lg font-semibold text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors ${isLoading ? 'bg-red-400 cursor-not-allowed' : 'bg-black hover:bg-red-700'}`}
            >
              {isLoading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Registering...
                </span>
              ) : 'Register'}
            </button>

            {/* Login Link */}
            <div className="text-center text-sm text-gray-600">
              Already have an account?{' '}
              <Link
                to="/login2"
                className="text-red-600 hover:text-red-800 font-medium transition-colors"
              >
                Sign in
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Workprovideregister;